import { Card, Col } from "reactstrap";
import CommonCardHeader from "../../../../Common/CommonCardHeader";
import { MultiFileUploads } from "../../../../Constant";
import { FILE_UPLOAD } from "../../../../Data/Bonus Ui/Dropzone";
import CommonFileUpload from "../../../../Common/CommonFileUpload";

const MultiFileUpload = () => {
  return (
    <Col lg="6">
      <Card>
        <CommonCardHeader title={MultiFileUploads} span={FILE_UPLOAD} />
        <CommonFileUpload multiple />
      </Card>
    </Col>
  );
};

export default MultiFileUpload;
